// Пара датасетов на странице «Сравнение»: из адреса (`?a=&b=`), иначе по умолчанию.

export interface NamedDataset {
  name: string;
  configHash: string | null;
}

/**
 * Пара по умолчанию — с РАЗНЫМИ отпечатками. Два датасета одного конфига
 * дают ноль переворотов по построению, и открывать страницу на таком
 * выборе значит показать пустоту вместо работы.
 */
export function defaultPair(datasets: readonly NamedDataset[]): { a: string | null; b: string | null } {
  const first = datasets[0];
  if (!first) return { a: null, b: null };
  const different = datasets.find((d) => d.configHash !== first.configHash);
  return {
    a: first.name,
    b: different?.name ?? datasets[Math.min(1, datasets.length - 1)]?.name ?? first.name,
  };
}

/** Пара из адреса; неизвестное имя заменяется значением по умолчанию. */
export function pairFromParams(params: URLSearchParams, datasets: readonly NamedDataset[]): { a: string | null; b: string | null } {
  const fallback = defaultPair(datasets);
  const known = (name: string | null) => (name !== null && datasets.some((d) => d.name === name) ? name : null);
  return { a: known(params.get('a')) ?? fallback.a, b: known(params.get('b')) ?? fallback.b };
}

/** Новые параметры адреса с одной стороной пары; прочие параметры (dataset) сохраняются. */
export function withPairSide(params: URLSearchParams, side: 'a' | 'b', name: string): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set(side, name);
  return next;
}
